<template>
  <v-row id="productList" no-gutters>
    <v-col v-for="product of products" :key="product.id" cols="12" md="4" class="d-flex justify-center align-center">
      <ProductsPreview :key="product.id" :id="product.id" :name="product.name" :image="product.image" :points="product.points" :description="product.description" />
    </v-col>
  </v-row>
</template>

<script>
  import ProductsPreview from "@/components/Products/Preview";

  export default {
    name: "ProductList",

    props: {
      products: {
        type: Array,
      },
    },

    components: { ProductsPreview },
  };
</script>



// WEBPACK FOOTER //
// src/components/Products/ProductList.vue